interface ErrorMessage {
    title: string;
    detail?: string;
    status?: number | string;
}

export const getErrorData = (error: Error | null): ErrorMessage => {
    if (error === null) {
        return { title: 'Ukjent feil' };
    }

    if (typeof error.message === 'string') {
        if (typeof error.name === 'string') {
            return { title: error.name, status: error.message };
        }
    }

    return { title: 'Ukjent feil' };
};
